import { useEffect, useState } from "react";
import VuiBox from "components/VuiBox";
import { AuthLayout } from "../../../layouts/authentication.layout";
import bgImage from "assets/images/backgrounds/auth-background.png";
import { AppSpinner } from "components/spinner.component";
import { SignInForm } from "modules/authentication/components/signin-form.component";
import { singInPageData } from "constants/signin-page.data";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { logoUrlImg, googleSignInClientId, baseUrl } from "../../../services/constants";
import { getUser } from "services/auth/auth.service";

export function SignIn() {
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(true);
  const [formErrors, setFormErrors] = useState({
    email: false,
    password: false,
  });
  const [hasPageLoad, setHasPageLoad] = useState(false);

  const history = useHistory();

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleLogin = (event) => {
    event.preventDefault();
    const payload = {
      email: event.target[0].value,
      password: event.target[1].value,
    }
    if (!payload.email) {
      setFormErrors({ ...formErrors, email: true });
      return;
    }
    if (!payload.password) {
      setFormErrors({ ...formErrors, password: true });
      return;
    }
    setLoading(true);
    fetch(singInPageData.loginEndpoint, {
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      method: "POST",
    }).then(r => r.json())
      .then(({ success, info, token }) => {
        setLoading(false);
        setSuccess(success);
        if (success) {
          const sessionData = {
            token,
            ...info,
            ibType: parseInt(info.ibType, 10)
          };
          localStorage.setItem('session', JSON.stringify(sessionData))
          console.log("Redirecting to dashboard...");
          history.push("/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
      })
  };

  const handleGoogleSignIn = () => {
    console.log("Google sign in se maneja automáticamente");
  };

  const handleGoogleCallback = (response) => {
    if (!response.credential) {
      console.error("No se recibió credential de Google");
      return;
    }

    setLoading(true);
    
    fetch(`${baseUrl}/session/login-ib/google`, {
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ idToken: response.credential }),
      method: "POST",
    })
      .then(r => r.json())
      .then((result) => {
        setLoading(false);
        
        if (result.success && result.token) {
          const sessionData = {
            token: result.token,
            ...result.info,
            ibType: parseInt(result.info.ibType, 10)
          };
          localStorage.setItem('session', JSON.stringify(sessionData));
          history.push("/dashboard");
        } else {
          setSuccess(false);
        }
      })
      .catch((error) => {
        console.error("Error en login con Google:", error);
        setLoading(false);
        setSuccess(false);
      });
  };

  useEffect(() => {
    const userLoggedIn = getUser();
    if (userLoggedIn) {
      history.push("/dashboard");
    }
    setHasPageLoad(true);

    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: googleSignInClientId,
        callback: handleGoogleCallback
      });
    }
  }, []);

  if (!hasPageLoad) return null;

  return (
    <AuthLayout
      image={bgImage}
      logo={logoUrlImg}
      title={singInPageData.page.title}
    >
      {!loading ?
        <SignInForm
          pageData={singInPageData}
          form={singInPageData.page.form}
          handleLogin={handleLogin}
          handleGoogleSignIn={handleGoogleSignIn}
          rememberMe={rememberMe}
          success={success}
          setSuccess={setSuccess}
          handleSetRememberMe={handleSetRememberMe}
         />
        : <VuiBox
          minWidth="450px"
          maxWidth="528px"
          sx={{
            padding: "90px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <AppSpinner />
        </VuiBox>}
    </AuthLayout>
  );
}
